


















import { computed, defineComponent, PropType, useContext } from '@nuxtjs/composition-api'
import { ICategoryMenuItem } from '@/contracts/Settings'

export default defineComponent({
  name: 'CategoryMenuItem',
  props: {
    item: {
      type: Object as PropType<
        ICategoryMenuItem & { internalIcon: string; id: string }
      >,
      default: () => ({}),
    },
  },
  emits: ['action'],
  setup(props, { emit }) {
    const ctx = useContext()
    const YM_ID = ctx.$config.YM_ID

    const handleAction = (item) => {
      emit('action', item)
    }

    const component = computed(() => {
      const ymEvent = props.item.ymEvent
      const onmousedown = ymEvent
        ? `ym(${ymEvent.ymId || YM_ID}, '${ymEvent.ymMethod}', '${ymEvent.ymTarget}'); return true;`
        : undefined

      if (props.item.url) {
        return {
          type: 'NuxtLink',
          props: {
            to: props.item.url,
            id: props.item.id,
            exactActiveClass: 'selected',
            onmousedown,
          },
        }
      }
      return { type: 'button', props: { id: props.item.id, onmousedown } }
    })
    return {
      component,
      handleAction,
    }
  },
})
